import type { IconProps } from '../types/IconProps.ts';
export const List: IconProps = {
    name: 'List',
    children: [
        `<circle cx="3" cy="5" r="1" />`,
        `<circle cx="3" cy="12" r="1" />`,
        `<circle cx="3" cy="19" r="1" />`,
        `<path d="M8 5h13M8 12h13M8 19h13" />`,
    ]
};